module.exports = __webpack_public_path__ + "img/tarantula_sql.1c4c310f.svg";